import type { GeneralSettings } from "@deskpro-product/messenger-api-schemas/messenger/config/settings";

export const getUserLocale = (
  generalSettings?: GeneralSettings,
  overrideLocale?: string,
): string => {
  const browserLocale =
    navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;
  const userLocale = overrideLocale || browserLocale;

  const defaultLocale = generalSettings?.defaultLanguage?.locale || "en-US";

  return (
    generalSettings?.availableLanguages?.find(({ locale }) => locale === userLocale)?.locale ||
    defaultLocale
  );
};
